<template>
  <div class="py-1">
    <span v-if="state === 'no-template'" class="text-gray-400 italic">No template uploaded</span>
    <span v-else-if="state === 'not-docx'" class="text-gray-400 italic">Not a .docx</span>
    <span v-else-if="state === 'error'" class="text-red-600">Error: {{ errorMessage }}</span>
    <span v-else-if="state === 'empty'" class="text-gray-400 italic">No merge fields in template</span>
    <span v-else-if="state === 'extracting'" class="text-gray-400 italic">Extracting tags…</span>
    <div v-else-if="state === 'success'" class="flex flex-wrap gap-1">
      <code 
        v-for="tag in tags" 
        :key="tag"
        class="bg-gray-100 px-1 py-0.5 rounded text-sm"
      >{{ "{" + tag + "}" }}</code>
    </div>
  </div>
</template>
<script>
import { defineComponent } from "@vue/runtime-core";

export default defineComponent({
  name: "TagsValue",
  computed: {
    rowItem() {
      return this.params.data;
    },
    state() {
      const item = this.rowItem;
      
      // No template uploaded
      if (!item.GeneratableFile) {
        return 'no-template';
      }
      
      // Check if file is .docx (case-insensitive)
      const filename = item.GeneratableFile;
      if (typeof filename === 'string' && !filename.toLowerCase().endsWith('.docx')) {
        return 'not-docx';
      }
      
      // Error state
      if (item.TagsError) {
        return 'error';
      }
      
      // Success state (Tags array exists or TagsMetadata exists)
      if (Array.isArray(item.Tags) || item.TagsMetadata) {
        if (Array.isArray(item.Tags) && item.Tags.length > 0) {
          return 'success';
        }
        return 'empty';
      }
      
      // Still extracting (GeneratableFile set, no Tags, no error, no metadata)
      return 'extracting';
    },
    tags() {
      if (Array.isArray(this.rowItem.Tags)) {
        return this.rowItem.Tags;
      }
      return [];
    },
    errorMessage() {
      const error = this.rowItem.TagsError;
      if (!error) return 'Unknown error';
      
      if (typeof error === 'object') {
        return error.error || 'Parse failed';
      }
      return String(error);
    }
  }
});
</script>
